module.exports = __webpack_public_path__ + "static/building_websites-93ceaf512c30b6c88ce74937b3466fc1.svg";